// v1.27.10 — Tri-color (Indian flag) animated banner for Independence Day
// (celebration around 15 Aug) and Republic Day (26 Jan). Pure CSS.
// v1.27.71 — Narrowed the active season to the actual national-holiday
// window as requested:
//   Independence Day: 13-Aug .. 16-Aug (inclusive)
//   Republic Day:     24-Jan .. 27-Jan (inclusive)
// Rest of the year the app stays fully on brand.

import React from "react";

const _now = () => new Date();
export function isTriColorSeason(d = _now()) {
    const m = d.getMonth() + 1; // 1-12
    const day = d.getDate();
    // Independence Day window: 13-Aug .. 16-Aug
    if (m === 8 && day >= 13 && day <= 16) return true;
    // Republic Day window: 24-Jan .. 27-Jan
    if (m === 1 && day >= 24 && day <= 27) return true;
    return false;
}

/**
 * Slim animated tri-color stripe. Use inside any header/banner as a top
 * or bottom trim. Automatically returns null outside the tri-color season
 * unless `always` is set.
 */
export function TriColorRibbon({ className = "", always = false }) {
    if (!always && !isTriColorSeason()) return null;
    return (
        <div
            aria-hidden
            data-testid="tricolor-ribbon"
            className={`tricolor-ribbon ${className}`}
        />
    );
}

/**
 * Small "waving" flag chip with spinning Ashoka Chakra + tricolor stripes.
 * Placed at the corner of a banner as a festive accent.
 */
export function TriColorWavingFlag({ label = "Happy Independence Day", always = false }) {
    if (!always && !isTriColorSeason()) return null;
    return (
        <div className="tricolor-flag-chip" data-testid="tricolor-waving-flag" title={label}>
            <div className="tricolor-flag" aria-hidden>
                <div className="tricolor-band tricolor-saffron" />
                <div className="tricolor-band tricolor-white">
                    <div className="tricolor-chakra" />
                </div>
                <div className="tricolor-band tricolor-green" />
            </div>
            <div className="tricolor-flag-label">{label}</div>
        </div>
    );
}
